const care = {
  residentCare: {
    hero: {
      eyebrow: "બીજું ઘર",
      title: "નિવાસી સંભાળ",
      subtitle: "એક પ્રેમાળ ઘર — સંસ્થા નહીં.",
    },
    items: {
      comfortableStay: {
        title: "આરામદાયક રહેઠાણ",
        desc: "સ્વચ્છ, હવાઉજાસવાળા ઓરડા અને દરેક માળે સેવકો.",
      },
      nutritiousMeals: {
        title: "પૌષ્ટિક ભોજન",
        desc: "ત્રણ ટંકનું ભોજન + ચા, વડીલોની આહારની જરૂરિયાત મુજબ તૈયાર.",
      },
      medicalCare: {
        title: "તબીબી સંભાળ",
        desc: "રોજિંદી દવાઓ, ઓન-કોલ ડોક્ટરો, હોસ્પિટલ સાથે જોડાણ.",
      },
      companionship: {
        title: "સંગાથ",
        desc: "સામૂહિક પ્રવૃત્તિઓ, સત્સંગ, તહેવારો અને જન્મદિવસની ઉજવણી.",
      },
      emotionalSupport: {
        title: "ભાવનાત્મક સહારો",
        desc: "કાઉન્સેલિંગ, પરિવાર સાથે વિડિયો કૉલ અને વ્યક્તિગત સંભાળ.",
      },
      ritualsDignity: {
        title: "વિધિ અને ગૌરવ",
        desc: "પુણ્ય તિથિ, અંતિમ સંસ્કાર અને સ્મરણ — આદર સાથે કરવામાં આવે છે.",
      },
    },
    form: {
      eyebrow: "પ્રવેશ માટે અરજી કરો",
      heading: "નિવાસી પ્રવેશ પૂછપરછ",
      description:
        "પ્રવેશ ઇચ્છતા વડીલની સંપૂર્ણ વિગતો શેર કરો. અમારી પ્રવેશ ટીમ 1–2 કાર્યકારી દિવસોમાં સંપર્ક કરશે.",
      select: "પસંદ કરો…",
      submit: "પ્રવેશ પૂછપરછ સબમિટ કરો",
      submitting: "સબમિટ થઈ રહ્યું છે...",
      sections: {
        resident: "નિવાસી વિગતો",
        health: "આરોગ્ય અને ગતિશીલતા",
        admission: "પ્રવેશ વિગતો",
        applicant: "અરજદાર / પરિવાર સંપર્ક",
      },
      labels: {
        residentName: "નિવાસીનું પૂરું નામ *",
        gender: "જાતિ",
        dob: "જન્મ તારીખ",
        bloodGroup: "બ્લડ ગ્રુપ",
        maritalStatus: "વૈવાહિક સ્થિતિ",
        religion: "ધર્મ",
        jainStatus: "જૈન સંપ્રદાય",
        caste: "જ્ઞાતિ / સમુદાય",
        education: "શિક્ષણ",
        occupation: "ભૂતકાળનો વ્યવસાય",
        residentMobile: "નિવાસીનો મોબાઇલ",
        aadhaar: "આધાર નંબર",
        identificationMark: "ઓળખ ચિહ્ન",
        previousAddress: "અગાઉનું સરનામું",
        city: "શહેર",
        state: "રાજ્ય",
        pincode: "પિનકોડ",
        healthConditions: "હાલની આરોગ્ય સમસ્યાઓ",
        currentMedications: "વર્તમાન દવાઓ",
        mobility: "ગતિશીલતા",
        admissionType: "પ્રવેશનો પ્રકાર",
        monthlyMaintenance: "માસિક નિભાવ બજેટ (₹)",
        preferredDate: "પસંદગીની પ્રવેશ તારીખ",
        referredBy: "સંદર્ભ આપનાર",
        reason: "પ્રવેશનું કારણ *",
        applicantName: "અરજદારનું નામ *",
        relation: "નિવાસી સાથેનો સંબંધ",
        mobile: "મોબાઇલ *",
        altMobile: "વૈકલ્પિક મોબાઇલ",
        email: "ઈમેલ",
        applicantAddress: "અરજદારનું સરનામું",
        emergencyName: "કટોકટી સંપર્ક નામ",
        emergencyMobile: "કટોકટી મોબાઇલ",
        emergencyRelation: "કટોકટી સંબંધ",
        notes: "વધારાની નોંધ",
      },
      placeholders: {
        bloodGroup: "દા.ત. B+",
        healthConditions: "ડાયાબિટીસ, બીપી, સાંધાનો દુખાવો, વગેરે.",
        relation: "પુત્ર / પુત્રી / ભત્રીજો…",
      },
      options: {
        gender: {
          male: "પુરુષ",
          female: "સ્ત્રી",
          other: "અન્ય",
        },
        marital: {
          single: "અપરિણીત",
          married: "પરિણીત",
          widowed: "વિધવા/વિધુર",
          divorced: "છૂટાછેડા",
        },
        jain: {
          shwetambar: "શ્વેતાંબર",
          digambar: "દિગંબર",
          sthanakvasi: "સ્થાનકવાસી",
          terapanthi: "તેરાપંથી",
          other: "અન્ય",
        },
        mobility: {
          independent: "સ્વતંત્ર",
          walkingStick: "લાકડી",
          walker: "વૉકર",
          wheelchair: "વ્હીલચેર",
          bedRidden: "પથારીવશ",
        },
        admission: {
          free: "નિ:શુલ્ક",
          paid: "સશુલ્ક",
          subsidised: "સબસિડીયુક્ત",
        },
      },
    },
    toast: {
      error: "સબમિટ કરી શકાયું નહીં.",
      success:
        "પૂછપરછ મળી. અમારી પ્રવેશ ટીમ 1–2 કાર્યકારી દિવસોમાં કૉલ કરશે.",
    },
  },

  healthcare: {
    hero: {
      eyebrow: "આરોગ્યસેવા",
      title: "જે સંભાળ રાહ જોતી નથી",
      subtitle:
        "રોજિંદી દવાઓથી લઈને મધ્યરાત્રિની કટોકટી સુધી, અમારો તબીબી કાર્યક્રમ અમારા વડીલોને સુરક્ષિત અને અમારા સમુદાયને સહારો આપે છે.",
    },
    metrics: {
      patientsServed: "દર વર્ષે સારવાર પામેલા દર્દીઓ",
      freeCamps: "દર વર્ષે નિ:શુલ્ક કેમ્પ",
      medicineKits: "વિતરિત દવા કિટ",
      emergency: "કટોકટી ઉપલબ્ધતા",
    },
    initiatives: {
      eyebrow: "આરોગ્યસેવા પહેલ",
      heading: "એક ક્લિનિક, એક કેમ્પ, એક એમ્બ્યુલન્સ — બધું એક છત નીચે",
      items: {
        clinic: {
          title: "પરિસરમાં ક્લિનિક",
          body: "4-કેબિનનું ક્લિનિક, રોજિંદા નર્સિંગ રાઉન્ડ અને વિવિધ વિશેષતાઓના મુલાકાતી નિષ્ણાતો સાથે.",
        },
        camps: {
          title: "નિ:શુલ્ક આરોગ્ય કેમ્પ",
          body: "દાંત, આંખ, ડાયાબિટીસ અને હૃદય તપાસ માટે માસિક કેમ્પ — નજીકના સમુદાયો માટે ખુલ્લા.",
        },
        medicine: {
          title: "દવા સહાય",
          body: "નિવાસીઓ અને અમારી સાથે નોંધાયેલા જરૂરિયાતમંદ વડીલો માટે માસિક નિ:શુલ્ક દવા કિટ.",
        },
        emergency: {
          title: "કટોકટી પ્રતિસાદ",
          body: "ચોવીસ કલાકની કટોકટી માટે પોતાની એમ્બ્યુલન્સ અને હોસ્પિટલ સાથે જોડાણ.",
        },
      },
    },
    programs: {
      eyebrow: "સારવાર કાર્યક્રમો",
      heading: "વિવિધ વિભાગોમાં સક્રિય સંભાળ",
      patients: "દર્દીઓ",
      items: {
        diabetes: "ડાયાબિટીસ વ્યવસ્થાપન",
        hypertension: "હાયપરટેન્શન સંભાળ",
        cardiac: "હૃદય દેખરેખ",
        physiotherapy: "ફિઝિયોથેરાપી",
        wellness: "સામાન્ય સ્વાસ્થ્ય",
        eye: "આંખની સંભાળ",
      },
    },
    support: {
      imgAlt: "નિયમિત તપાસ કરતા ડોક્ટર",
      eyebrow: "તબીબી સહાય પ્રવૃત્તિઓ",
      heading: "જ્યાં દરેક તપાસ મહત્વની છે",
      items: {
        monitoring:
          "જોખમ ધરાવતા નિવાસીઓ માટે રોજિંદી બ્લડ-પ્રેશર અને સુગરની દેખરેખ.",
        dental: "ત્રિમાસિક નિ:શુલ્ક દાંતનો કેમ્પ — સ્થાનિક સમુદાય માટે ખુલ્લો.",
        vaccination:
          "વર્ષમાં બે વાર રસીકરણ અભિયાન (ફ્લૂ, ન્યુમોનિયા, COVID બૂસ્ટર).",
        lab: "પડતર કિંમતે નિદાન માટે લેબ જોડાણ — નિવાસીઓ માટે ફી માફ.",
        counselling: "વડીલોના માનસિક સ્વાસ્થ્ય માટે કાઉન્સેલિંગ અને યોગ સત્રો.",
      },
    },
    cta: {
      heading: "એક દિવસની તબીબી સંભાળ પ્રાયોજિત કરો",
      description:
        "એક વડીલ માટે, એક દિવસ માટે ડોક્ટરની મુલાકાત, દવાઓ અને નિદાનનો ખર્ચ ઉઠાવો.",
      support: "આરોગ્યસેવાને સહકાર આપો",
      getInTouch: "સંપર્ક કરો",
    },
  },

  elderCare: {
    hero: {
      eyebrow: "વડીલ સંભાળ",
      title: "આજીવન સંભાળ, ગૌરવ સાથે",
      subtitle:
        "આશ્રય, ભોજન, દવા, સંગાથ અને વિધિઓ — પરિવારની હૂંફ સાથે પૂરા પાડવામાં આવે છે, ક્યારેય દાન તરીકે નહીં.",
    },
    impact: {
      residentsCared: "સંભાળ પામેલા નિવાસીઓ",
      lifetimeCare: "આજીવન સંભાળના",
      mealsServed: "દર વર્ષે પીરસાયેલું ભોજન",
      donorFunded: "દાતા દ્વારા ભંડોળ",
    },
    overview: {
      eyebrow: "કાર્યક્રમ ઝાંખી",
      heading: "ઓરડા અને ભોજનથી આગળ વધતી સંભાળ",
      description:
        "દરેક નિવાસીને એક સમાન સ્તરની સંભાળ મળે છે — ભલે તેઓ સાધન સાથે આવ્યા હોય કે કંઈ પણ વગર.",
    },
    services: {
      shelter: {
        title: "આજીવન આશ્રય",
        body: "સ્વચ્છ, સુરક્ષિત ઓરડો અને પરિવારના ભોજનમાં સ્થાન — જ્યાં સુધી અમારા વડીલોને જરૂર હોય ત્યાં સુધી, વિના મૂલ્યે.",
      },
      bhojan: {
        title: "દૈનિક ભોજન સેવા",
        body: "દરરોજ ત્રણ પૌષ્ટિક, તાજાં રાંધેલા જૈન-શૈલીના ભોજન, આહારની જરૂરિયાતને ધ્યાનમાં રાખીને આયોજિત.",
      },
      care: {
        title: "ચોવીસ કલાક સંભાળ",
        body: "પ્રશિક્ષિત સંભાળકર્તાઓ, સાપ્તાહિક ડોક્ટર રાઉન્ડ અને સહાયની જરૂર હોય તેવા નિવાસીઓ માટે 24×7 નર્સિંગ.",
      },
      dignity: {
        title: "ગૌરવ અને વિધિઓ",
        body: "જન્મદિવસ, તહેવારો અને અંતિમ સંસ્કાર પરિવાર જેવી જ સંભાળ સાથે ઉજવાય છે.",
      },
    },
    facilities: {
      imgAlt: "સાથે ભોજનનો આનંદ માણતા નિવાસીઓ",
      eyebrow: "સુવિધાઓ અને સેવાઓ",
      heading: "અમારા વડીલોને કેન્દ્રમાં રાખીને બનેલું ઘર",
      description:
        "ગતિશીલતા, સલામતી અને સમુદાયને ધ્યાનમાં રાખીને રચાયેલું — દરેક ખૂણાનો એક હેતુ છે.",
      items: {
        capacity: "A, B અને C બ્લોકમાં 120+ નિવાસીઓની ક્ષમતા",
        clinic: "રોજિંદા નર્સિંગ રાઉન્ડ સાથેનું પોતાનું ક્લિનિક",
        physio: "ફિઝિયોથેરાપી અને યોગ ખંડ",
        library: "પુસ્તકાલય, પ્રાર્થના ખંડ અને સત્સંગ સ્થળ",
        access: "સર્વત્ર વ્હીલચેર-અનુકૂળ પ્રવેશ",
        garden: "બગીચો, ચાલવાના માર્ગ અને બહારની બેઠક",
      },
    },
    stories: {
      eyebrow: "પ્રભાવ ગાથાઓ",
      heading: "અમારા પરિવારના અવાજો",
      items: {
        kantilal: {
          name: "કાંતિલાલ ભાઈ",
          years: "અમારી સાથે 12 વર્ષ",
          quote: "હું એકલો આવ્યો હતો. હવે મારે પરિવાર છે — 119 ભાઈઓ અને બહેનો.",
        },
        saroj: {
          name: "સરોજ બેન",
          years: "અમારી સાથે 5 વર્ષ",
          quote:
            "અહીં આવ્યા પછી દરેક જન્મદિવસે કેક હોય છે. હું ભૂલી ગઈ હતી કે એ કેવું લાગે છે.",
        },
        hasmukh: {
          name: "હસમુખ ભાઈ",
          years: "અમારી સાથે 9 વર્ષ",
          quote:
            "જ્યારે હું બીમાર પડ્યો, ત્યારે ડોક્ટર મધ્યરાત્રિએ આવ્યા. બીજે ક્યાં આવું બને?",
        },
      },
    },
    gallery: {
      eyebrow: "ફોટો ગેલેરી",
      heading: "અમારા ઘરની ક્ષણો",
      viewFull: "સંપૂર્ણ ગેલેરી જુઓ",
      items: {
        care: "કરુણામય સંભાળ",
        meals: "સહિયારું ભોજન",
        health: "રોજિંદી આરોગ્ય તપાસ",
      },
    },
    cta: {
      heading: "એક વડીલની સંભાળ પ્રાયોજિત કરો",
      description:
        "તમારો સહકાર Jivandhara ને ઘર માનતા વડીલો માટે આશ્રય, ભોજન અને દવાનું ભંડોળ પૂરું પાડે છે.",
      support: "વડીલ સંભાળને સહકાર આપો",
      visit: "ઘરની મુલાકાત લો",
    },
  },
};

export default care;
